import { Typography } from "@mui/material";
import { useSimpleFormIteratorItem } from "react-admin";

const IndexField = () => {
  const { index } = useSimpleFormIteratorItem();

  return (
    <Typography
      variant="body2"
      sx={{ alignSelf: "center" }}
    >
      #{index + 1}:
    </Typography>
  );
};

export default IndexField;
